// extracted by mini-css-extract-plugin
export default {"productSpecs":"ProductSpecs_productSpecs__fvu4P"};